import React from 'react'
import Modal from '../../../../UI/Modal/Modal'
import ModalFooter from './ModalFooter/ModalFooter'
import ModalBody from './ModalBody/ModalBody'

const GradeCriteriaModal = ({
  open,
  submitDisabled,
  submittedHandler,
  cancelledHandler,
  form,
  formInputChanged,
  additionalForm,
  additionalFormInputChanged,
  gradeLevelRows,
  gradeLevelRowInputChanged,
  percentError,
  translate
}) => {
  return (
    <Modal
      open={open}
      onHide={cancelledHandler}
      header={translate('gradeCriteria')}
      size={'lg'}
      footer={
        <ModalFooter
          saved={submittedHandler}
          cancelled={cancelledHandler}
          saveDisabled={submitDisabled}
        />
      }>
      <ModalBody
        form={form}
        formInputChanged={formInputChanged}
        additionalForm={additionalForm}
        additionalFormInputChanged={additionalFormInputChanged}
        gradeLevelRows={gradeLevelRows}
        gradeLevelRowInputChanged={gradeLevelRowInputChanged}
        percentError={percentError}
        translate={translate}
      />
    </Modal>
  )
}

export default GradeCriteriaModal
